import { StyledContainer, StyledRing } from './ColorSelectColorItem.styled';

const ColorSelectColorItem = ({
	color,
	selected,
	onClick,
}: {
	color: string;
	selected: boolean;
	onClick: () => void;
}) => {
	return (
		<StyledContainer
			$selected={selected}
			style={{ background: color }}
			onClick={onClick}
		>
			<StyledRing />
		</StyledContainer>
	);
};

export { ColorSelectColorItem };
